import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import SuccessImage from 'shared/images/success-beket.webp'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

type Props = {
  onClick: () => void
}

export const BeketSuccess = ({ onClick }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={clsx('container', 'safe-area-top-padding', s.container)}>
      <div className={s.content}>
        <img
          src={SuccessImage}
          className={s.successImage}
          alt=""
        />

        <div className={s.text}>
          <h3 className={s.title}>{t('beket_content.success_title')}</h3>
          <p className={clsx(s.description, 'medium-16')}>
            {t('beket_content.success_description')}
          </p>
        </div>

        <div className={s.btnContainer}>
          <Button
            variant="grey"
            onClick={onClick}
          >
            <span className={clsx(s.buttonText, 'bold-16')}>
              {t('excursions.my_orders')}
            </span>
          </Button>
        </div>
      </div>
    </div>
  )
}
